import React, { useState, useEffect } from "react";

const AboutToshni = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    section: {
      padding: isMobile ? "40px 15px" : "80px 20px",
      background: "linear-gradient(to bottom, #fff0f5, #ffffff)",
      fontFamily: "'Playfair Display', serif",
    },
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      padding: isMobile ? "30px 20px" : "60px",
      borderRadius: "12px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    },
    mainTitle: {
      textAlign: "center",
      fontSize: isMobile ? "28px" : "42px",
      color: "#c2185b",
      marginBottom: isMobile ? "25px" : "40px",
      fontWeight: "600",
    },
    subTitle: {
      fontSize: isMobile ? "18px" : "22px",
      color: "#ad1457",
      marginTop: "30px",
      marginBottom: "15px",
      fontWeight: "600",
    },
    text: {
      fontSize: isMobile ? "14px" : "16px",
      lineHeight: "1.9",
      color: "#555",
      marginBottom: "20px",
      fontFamily: "Arial, sans-serif",
    },
    list: {
      paddingLeft: "20px",
      lineHeight: "1.9",
      color: "#555",
      fontSize: isMobile ? "14px" : "16px",
      fontFamily: "Arial, sans-serif",
    },
    highlight: {
      color: "#d81b60",
      fontWeight: "600",
    },
  };

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.mainTitle}>About Toshni Jewellers</h1>

        <p style={styles.text}>
          <span style={styles.highlight}>Toshni Jewellers</span> is a trusted
          destination for premium jewellery that reflects elegance,
          craftsmanship and timeless beauty. We specialize in creating and
          curating jewellery that blends traditional artistry with modern
          designs, ensuring every piece becomes a cherished memory.
        </p>

        <p style={styles.text}>
          Our collections are thoughtfully designed to celebrate life’s most
          special occasions — from weddings and festivals to everyday elegance.
          With a strong commitment to quality and customer satisfaction, we
          strive to offer jewellery that symbolizes trust, purity and style.
        </p>

       <h2 style={styles.subTitle}>Our Collection</h2>

<p style={styles.text}>
  We proudly offer a wide variety of jewellery collections crafted with
  precision and elegance:
</p>

<ul style={styles.list}>
  <li>✨ Gold Jewellery – Bridal, Wedding & Daily Wear Collections</li>
   <li>✨ Silver Jewellery – Lightweight & Affordable Designs</li>
  <li>✨ Diamond Jewellery – Elegant Rings, Necklaces & Designer Sets</li>
   <li>✨ Stone Jewellery – Party Wear & Festive Collections</li>
  <li>✨ Oxidised Jewellery – Trendy Traditional Fusion Styles</li>
</ul>


        <h2 style={styles.subTitle}>Our Promise</h2>

        <p style={styles.text}>
          At Toshni Jewellers, we believe jewellery is more than just an
          accessory — it is an emotion and a legacy. Every piece is crafted
          with attention to detail and dedication to excellence. Our focus on
          quality, authenticity and personalized service ensures that every
          customer enjoys a premium shopping experience.
        </p>

        <h2 style={styles.subTitle}>Why Choose Toshni Jewellers?</h2>

        <ul style={styles.list}>
          <li>✔ Premium Quality & Trusted Craftsmanship</li>
          <li>✔ Latest & Exclusive Designs for Every Occasion</li>
          <li>✔ Transparent Pricing & Customer Satisfaction</li>
          <li>✔ Friendly & Personalized Service Experience</li>
        </ul>
      </div>
    </section>
  );
};

export default AboutToshni;
